/* eslint-env browser */
/* eslint-disable complexity */
import { inject, observer } from 'mobx-react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import * as React from 'react';

import { ILocalization, withLocalization } from 'bernie-l10n';

import { Experiment, ExperimentControl, ExperimentVariant } from '@shared-ui/experiment-context';

import { SearchResultsStore } from 'stores/search-results-store';

import { SortAndFilterModel } from 'components/common/search-form/fields/filter-types';

import { UitkSpacing } from 'uitk-react-spacing';

import { MapPreview } from 'src/common/components/search/map/map-preview';
import { parse } from 'query-string';
import { SearchForm } from 'components/common/search-form';

export interface SidebarProps extends RouteComponentProps {
  searchResults?: SearchResultsStore;
  isActive: boolean;
  l10n?: ILocalization;
  withFilters?: boolean;
}

@withLocalization
@inject('searchResults')
@observer
class SidebarComponent extends React.Component<SidebarProps> {
  public static defaultProps = {
    isActive: false,
    l10n: null,
    withFilters: true,
  };

  public scrollToTop() {
    window.scrollTo(0, 0);
  }

  // eslint-disable-next-line complexity
  public render() {
    const { searchResults, isActive, withFilters } = this.props;
    const searchCriteria = searchResults && searchResults.searchCriteria;
    const regionId = searchCriteria && searchCriteria.regionId;
    const latLong = searchCriteria && searchCriteria.latLong;
    const group = searchCriteria && searchCriteria.group;
    const { l10n, location } = this.props;
    const { formatText } = l10n;

    const searchResultsCriteria = searchResults && searchResults.searchCriteria;
    const sortAndFilterOptions: SortAndFilterModel = searchResults && searchResults.sortAndFilter && searchResults.sortAndFilter.options;
    const sortAndFilterDefaults: any = searchResults && searchResults.sortAndFilter && searchResults.sortAndFilter.defaults;
    const filters = searchResults && searchResults.searchAndFilterDisplayOptions && searchResults.searchAndFilterDisplayOptions.filters;
    const displayFields = filters && filters.displayFields;
    const ignoreFields = filters && filters.ignoreFields;
    const mapImage = searchResults && searchResults.map && searchResults.map.staticMapSrc;
    const pwaMapOverlay: boolean = Boolean(parse(location.search).pwaOverlay === 'map');
    const shouldShowSidebar = regionId || latLong || group || sortAndFilterOptions;
    const displayFieldsNoSort = displayFields && displayFields.filter(item => item !== 'sort');

    return (
      <>
        {shouldShowSidebar && (
          <section data-stid="desktop-sidebar">
            {searchResults && searchResults.map && (
              <div>
                <MapPreview isActive={isActive} mapImage={mapImage} />
              </div>
            )}
            {withFilters && (
              <>
                <h2 className="is-visually-hidden">{formatText('hotels.searchResults.filtersDialog.title')}</h2>
                {!pwaMapOverlay && (
                  <Experiment name="Lodging_SRP_Lazyload_Desktop_Filters">
                    <ExperimentControl>
                      <UitkSpacing padding={{ blockend: 'twelve' }}>
                        <SearchForm
                          model={searchResultsCriteria}
                          sortAndFilterOptions={sortAndFilterOptions}
                          sortAndFilterDefaults={sortAndFilterDefaults}
                          provideDefaultSubmitButton={false}
                          displayFields={displayFieldsNoSort}
                          ignoreFields={ignoreFields}
                          autoSubmit={true}
                          searchable={true}
                          afterSubmit={this.scrollToTop}
                        />
                      </UitkSpacing>
                    </ExperimentControl>
                    <ExperimentVariant bucket={1}>
                      <UitkSpacing padding={{ blockend: 'twelve' }}>
                        <SearchForm
                          model={searchResultsCriteria}
                          sortAndFilterOptions={sortAndFilterOptions}
                          sortAndFilterDefaults={sortAndFilterDefaults}
                          provideDefaultSubmitButton={false}
                          displayFields={displayFieldsNoSort}
                          ignoreFields={ignoreFields}
                          autoSubmit={true}
                          searchable={true}
                          afterSubmit={this.scrollToTop}
                          lazyLoadFromIndex={7}
                        />
                      </UitkSpacing>
                    </ExperimentVariant>
                  </Experiment>
                )}
              </>
            )}
          </section>
        )}
      </>
    );
  }
}

export const Sidebar = withRouter(SidebarComponent);
